const home = require("./home").messages;

module.exports = {
    messages: {
        de: {
            citation: {
                accessed: "Zugriff",
                in: "In",
                recommendation: "Zitierempfehlung",
                title: home.de.home.title
            }
        },
        en: {
            citation: {
                accessed: "Accessed",
                in: "In",
                recommendation: "Recommended citation",
                title: home.en.home.title
            }
        },
        fr: {
            citation: {
                accessed: "Consulté le",
                in: "Dans",
                recommendation: "Citation recommandée",
                title: home.fr.home.title
            }
        }
    }
}
